var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 3.5C13.9873 3.5 17.3045 6.30205 18 10C17.3045 13.6979 13.9873 16.5 10 16.5C6.01269 16.5 2.69547 13.6979 2 10C2.69547 6.30205 6.01269 3.5 10 3.5ZM10 15.0556C13.1321 15.0556 15.8122 12.9264 16.4906 10C15.8122 7.07358 13.1321 4.94444 10 4.94444C6.86787 4.94444 4.18777 7.07358 3.50935 10C4.18777 12.9264 6.86787 15.0556 10 15.0556ZM10 13.25C8.16222 13.25 6.6724 11.7949 6.6724 10C6.6724 8.20508 8.16222 6.75 10 6.75C11.8377 6.75 13.3276 8.20508 13.3276 10C13.3276 11.7949 11.8377 13.25 10 13.25ZM10 11.8056C11.021 11.8056 11.8487 10.9972 11.8487 10C11.8487 9.00283 11.021 8.19444 10 8.19444C8.97904 8.19444 8.15133 9.00283 8.15133 10C8.15133 10.9972 8.97904 11.8056 10 11.8056Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeLine);
export default __webpack_public_path__ + "static/media/eye-line.a6e7b4e73e1494fb0415949166bb2f05.svg";
export { ForwardRef as ReactComponent };